"use strict";

exports.__esModule = true;
exports.ChartControlsSelector = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@blueprintjs/core");
var _Core = require("../../Core");
var _helper = require("../../Widgets/MeasureChart/helper");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var ChartControlsSelector = exports.ChartControlsSelector = function ChartControlsSelector(props) {
  var _useContext = (0, _react.useContext)(_Core.TranslatorContext),
    translate = _useContext.translate;
  var elementEditor = props.elementEditor,
    path = props.path,
    controls = props.controls;
  (0, _react.useEffect)(function () {
    if (!controls || Object.entries(controls).length === 0) {
      elementEditor.modifyElementAt(path, function (el) {
        return {
          item: "el.props.controls",
          value: el.props.controls = {
            showDeviceNameInItem: false,
            showUnitInItem: false,
            hideLegend: false,
            hideTooltip: false
          }
        };
      });
    }
  }, [controls, elementEditor, path]);
  return /*#__PURE__*/_react["default"].createElement(_helper.Well, {
    "data-testid": "ChartControlsSelector"
  }, /*#__PURE__*/_react["default"].createElement(_helper.WellTitle, null, translate("ChartControlsSelector.controlOptions.label", "Controls options")), /*#__PURE__*/_react["default"].createElement(_core.Switch, {
    label: translate("ChartControlsSelector.controlsShowDeviceName.label", "Show device name in item"),
    "data-testid": "ChartControlsSelector.controlsShowDeviceName.switch",
    checked: controls == null ? void 0 : controls.showDeviceNameInItem,
    onChange: function onChange(e) {
      return elementEditor.modifyElementAt(path, function (el) {
        return {
          item: "el.props.controls.showDeviceNameInItem",
          value: el.props.controls.showDeviceNameInItem = e.target.checked
        };
      });
    }
  }), /*#__PURE__*/_react["default"].createElement(_core.Switch, {
    label: translate("ChartControlsSelector.controlsShowUnit.label", "Show unit in item"),
    "data-testid": "ChartControlsSelector.controlsShowUnit.switch",
    checked: controls == null ? void 0 : controls.showUnitInItem,
    onChange: function onChange(e) {
      return elementEditor.modifyElementAt(path, function (el) {
        return {
          item: "el.props.controls.showUnitInItem",
          value: el.props.controls.showUnitInItem = e.target.checked
        };
      });
    }
  }), /*#__PURE__*/_react["default"].createElement(_core.Switch, {
    label: translate("ChartControlsSelector.controlsHideLegend.label", "Hide legend"),
    "data-testid": "ChartControlsSelector.controlsHideLegend.switch",
    checked: controls == null ? void 0 : controls.hideLegend,
    onChange: function onChange(e) {
      return elementEditor.modifyElementAt(path, function (el) {
        return {
          item: "el.props.controls.hideLegend",
          value: el.props.controls.hideLegend = e.target.checked
        };
      });
    }
  }), /*#__PURE__*/_react["default"].createElement(_core.Switch, {
    label: translate("ChartControlsSelector.controlsHideTooltip.label", "Hide tooltip"),
    "data-testid": "ChartControlsSelector.controlsHideTooltip.switch",
    checked: controls == null ? void 0 : controls.hideTooltip,
    onChange: function onChange(e) {
      return elementEditor.modifyElementAt(path, function (el) {
        return {
          item: "el.props.controls.hideTooltip",
          value: el.props.controls.hideTooltip = e.target.checked
        };
      });
    }
  }));
};